import React from 'react'

interface SvgIconProps extends React.SVGProps<SVGSVGElement> {
  fill?: string
}

const SvgIcon: React.FC<SvgIconProps> = ({ fill = 'currentColor', ...props }) => {
  return (
    <svg {...props} fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path d="M5 21q-.825 0-1.413-.587Q3 19.825 3 19v-4h2v4h4v2Zm10 0v-2h4v-4h2v4q0 .825-.587 1.413Q19.825 21 19 21ZM3 9V5q0-.825.587-1.413Q4.175 3 5 3h4v2H5v4Zm16 0V5h-4V3h4q.825 0 1.413.587Q21 4.175 21 5v4Z" />
    </svg>
  )
}

type CropFreeProps = SvgIconProps

export const CropFree: React.FC<CropFreeProps> = (props) => {
  return <SvgIcon {...props} viewBox="0 0 24 24" focusable="false" aria-hidden="true" />
}
